// @flow
import React, { PureComponent } from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import { toggleVideoById } from '../../actions/video'
import VideoPlayer from '../VideoPlayer/videoPlayer'
import type { VideoProps } from '../../types'
import styles from './video.css'

class Video extends PureComponent {
  props: VideoProps

  onVideoAndCloseClick = (): void => {
    const { dispatch, videoId } = this.props
    dispatch(toggleVideoById(videoId))
  }

  getCurrentShowVideoState (): boolean {
    const { videos, videoId } = this.props
    const currentVideo = videos.filter((video) => video.id === videoId)[0]
    if (typeof currentVideo === 'undefined') {
      return false
    }
    return currentVideo.isOpen
  }

  render () {
    const { poster, subtitle, quote, name, videoId } = this.props
    const isVideoShow = this.getCurrentShowVideoState()
    return (
      <li onClick={this.onVideoAndCloseClick} className={styles.videoItem}>
        <div className={styles.playcircle}>
          <svg aria-hidden><use xlinkHref='#nrk-media-play' /></svg>
        </div>
        <p>
          <span>{subtitle}</span>
          <span>{quote}</span>
          <span>{name}</span>
        </p>
        <img className={styles.videoimg} src={poster} />
        <Modal
          contentLabel='Modal'
          className={styles.videoModal}
          overlayClassName={styles.videoOverlay}
          isOpen={isVideoShow}
          onRequestClose={this.onVideoAndCloseClick}>
          <button
            onClick={this.onVideoAndCloseClick}
            className={`nrk-button nrk-button--o ${styles.videoModalClose}`}>
            <svg><use xlinkHref='#nrk-close' /></svg>
          </button>
          <VideoPlayer videoId={videoId} />
        </Modal>
      </li>
    )
  }
}

export default connect((state) => {
  return {
    videos: state.video.videos
  }
})(Video)



// WEBPACK FOOTER //
// ./src/shared/components/Video/video.js